<template>
  <div>
    <p>
      <b>{{ $t('page.campuses.para1') }}.</b> {{ $t('page.campuses.para2') }}
      <b>{{ $t('page.campuses.para3') }}</b>
    </p>
    <a-row :gutter="20" class="campuses">
      <a-col :span="isDesktop ? 16 : 24">
        <a-card :title="$t('cardTitle.howToAddChurchLocation')" class="reset-padding style1" v-if="!isAdmin">
          <iframe src="https://player.vimeo.com/video/444584212" width="640" height="480" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </a-card>

        <a-card :title="$t('cardTitle.' + (isAdmin ? 'locations' : 'yourLocations'))" class="style1 location-list">
          <p v-if="empty(locationList)" style="text-align: center; font-size: 24px">{{ $t('page.campuses.yourLocations.para1') }}</p>
          <ul v-else>
            <li v-for="location in locationList" :key="location.key" @click="selectLocation(location)" :class="`${isMobile ? 'mobile' : ''} ${selected === location.id ? 'selected' : ''}`">
              <div>
                <b>{{ location.name }}</b>
                <p v-if="location.address2">{{ `${location.address} ${location.address2}, ${location.city}, ${location.state}, ${location.country}, ${location.zipcode}` }}</p>
                <p v-else>{{ `${location.address}, ${location.city}, ${location.state}, ${location.country}, ${location.zipcode}` }}</p>
              </div>
              <img
                :src="`http://maps.google.com/maps/api/staticmap?size=450x300&amp;sensor=false&amp;zoom=14&amp;markers=${location.latitude}%2C${location.longitude}&amp;key=AIzaSyCgAHqRDxO08kAM6AEgklKLkbVTYGDMpaw`"
                :alt="`Staticmap?size=450x300&amp;sensor=false&amp;zoom=14&amp;markers=${location.latitude}%2C${location.longitude}`"
              />
            </li>
          </ul>
        </a-card>
      </a-col>
      <a-col :span="isDesktop ? 8 : 24">
        <a-card :title="updateLocationTitle" class="style1" id="formLocations">
          <a-form :form="form" :label-col="isDesktop ? { span: 6 } : {}" :wrapper-col="isDesktop ? { span: 18 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
            <a-form-item label="Church Name">
              <a-input v-decorator="['name', { rules: [{ required: true, message: $t('placeholder.pleaseInputTheLocationName') }] }]" />
            </a-form-item>
            <a-form-item :label="$t('label.address')">
              <a-input v-decorator="['address', { rules: [{ required: true, message: $t('placeholder.pleaseInputYourAddress') }] }]" />
            </a-form-item>
            <a-form-item :label="$t('label.address2')">
              <a-input v-decorator="['address2']" />
            </a-form-item>
            <a-form-item :label="$t('label.city')">
              <a-input v-decorator="['city', { rules: [{ required: true, message: $t('placeholder.pleaseInputYourCity') }] }]" />
            </a-form-item>
            <a-form-item :label="$t('label.state')">
              <a-input v-decorator="['state', { rules: [{ required: true, message: $t('placeholder.pleaseInputYourState') }] }]" />
            </a-form-item>
            <a-form-item :label="$t('label.zipCode')">
              <a-input v-decorator="['zipcode', { rules: [{ required: true, message: $t('placeholder.pleaseInputYourZipcode') }] }]" />
            </a-form-item>
            <a-form-item :label="$t('label.country')">
              <a-input v-decorator="['country', { rules: [{ required: true, message: $t('placeholder.pleaseInputYourCountry') }] }]" />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <div class="d-flex justify-content-between">
                <a-button type="primary" html-type="submit" :loading="isLoading">{{ isUpdate ? $t('button.updateLocation') : $t('button.createLocation') }}</a-button>
                <a-button type="primary" v-if="isUpdate" @click="onResetForm">{{ $t('button.createLocation') }}</a-button>
              </div>
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
    <a-modal :title="null" centered :footer="null" :visible="showPermAlert" :closable="false">
      <div style="text-align: center">
        <p>Warning! You cannot create more than one location at a time. If you need help please contact the administrator.</p>
        <a-button
          type="primary"
          class="tf-btn tf-btn-primary"
          @click="
            e => {
              showPermAlert = false;
            }
          "
        >
          OK
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import LocationService from '@/services/LocationService';
import AdminService from '@/services/AdminService';
import { mapState } from 'vuex';
import { get, map } from 'lodash';
import { empty } from '@/utils';
export default {
  props: {
    campuses: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    isLoading: false,
    isUpdate: false,
    locationList: [],
    selected: '',
    location_id: null,
    showPermAlert: false,
  }),

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'validate_other' });
  },
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    isMobile() {
      return this.settings.isMobileView;
    },
    updateLocationTitle() {
      if (this.isAdmin) {
        return this.$t('cardTitle.churchLocation.' + this.isUpdate ? 'adminUpdate' : 'adminAdd');
      }
      return this.$t('cardTitle.churchLocation.' + this.isUpdate ? 'update' : 'add');
    },
  },
  async mounted() {
    await this.doInitData();
  },
  watch: {
    campuses(data) {
      this.locationList = map(data, (item, index) => ({
        ...item,
        key: index,
      }));
    },
  },
  methods: {
    empty,
    async doInitData() {
      let resp = [];
      if (this.isAdmin) {
        resp = this.campuses;
      } else {
        resp = await LocationService.getMyLocations();
      }
      this.locationList = map(resp, (item, index) => ({
        ...item,
        key: index,
      }));
    },
    onResetForm() {
      this.isUpdate = false;
      this.form.resetFields();
      this.selected = '';
    },
    selectLocation(record) {
      this.selected = record.id;
      this.isUpdate = true;
      this.location_id = record.id;
      if (!this.isDesktop) {
        document.getElementById('formLocations').scrollIntoView();
      }
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: record.name,
          address: record.address,
          address2: record.address2,
          city: record.city,
          country: record.country,
          zipcode: record.zipcode,
          state: record.state,
        });
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            if (!this.isAdmin) {
              if (!this.isUpdate && this.locationList.length) {
                this.showPermAlert = true;
                return;
              }

              await (this.isUpdate ? LocationService.doUpdateLocation({ ...values, location_id: this.location_id }) : LocationService.doAddLocation(values));
              await this.doInitData();
            } else {
              await (this.isUpdate ? AdminService.location.update(this.location_id, values) : LocationService.doAddLocation(values));
              this.$emit('onSuccess');
            }
            this.$notification['success']({
              message: 'Location',
              description: this.isUpdate ? 'You have successfully updated location!' : 'You have successfully added new location!',
            });
          } catch (error) {
            console.log(error);
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.campuses {
  .location-list {
    .ant-card-body {
      padding: 10px;
      height: 540px;
      overflow: auto;
    }
  }
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #6c757d;
      padding: 10px;
      border-radius: 4px;
      margin-bottom: 10px;
      cursor: pointer;
      img {
        max-width: 200px;
      }
      &.mobile {
        flex-direction: column;
        align-items: flex-start;
      }
      &.selected {
        background: rgba(#23c6c8, 0.2);
      }
    }
  }
}
</style>
